// extracted by mini-css-extract-plugin
export default {"container":"video-container_container__tT3HL","message":"video-container_message__FoyPW","hide":"video-container_hide__1Y1lY"};